import React from 'react';

import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPSearchForm from 'components/notification/notificationList/search-form';
import SPTable from 'components/notification/notificationList/table';
import SPDrawer from 'components/order-management/order-list/drawer';
import SPPageActionBar from "../../../components/notification/notificationList/page-action-bar";
import SPModal from "../../../components/notification/notificationList/modal";
import SPContentWrap from '../../../components/carRental/base/SPContentWrap';
import SPVenhicleDrawer from '../../../components/carRental/vehicleManagement/SPVenhicleDrawer';

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;
	return (
		<>
			<SPBreadcrumb title="通知管理" />
			<SPContentWrap className="common-margin-top">
				<SPSearchForm enums={enums} />
			</SPContentWrap>
			<SPContentWrap className='page-action-bar'>
            <SPPageActionBar permission={permission}></SPPageActionBar>
        </SPContentWrap>
			<SPTable permission={permission} enums={enums} />
			<SPDrawer enums={enums} />
			<SPVenhicleDrawer enums={enums} />
			<SPModal></SPModal>
		</>
	);
};

export default SPPage;
